<template>
  <div class="tw-flex tw-flex-col sm:tw-items-center tw-justify-center tw-h-screen tw-bg-gray-100">
    <base-card shadow no-padding class="tw-overflow-hidden tw-w-full sm:tw-max-w-sm">
      <div class="tw-py-8 tw-flex tw-justify-center tw-mb-1" :class="{ 'tw-bg-primary-500': logo === 'rx-harmony-logo' }">
        <component :is="logo" class="tw-w-3/4 tw-max-h-32" />
      </div>
      <base-content>
        <div class="tw-text-xl tw-text-gray-800 tw-text-center tw-font-normal">Success!</div>
        <p class="tw-text-sm tw-text-center tw-mt-2 tw-text-gray-600">
          {{ message }}
        </p>
        <base-button class="tw-w-full tw-mt-4" @click="href('/signin')">
          Sign in
        </base-button>
      </base-content>
    </base-card>
  </div>
</template>

<script>
import PredictileLogo from "@/assets/images/predictile-logo-square.svg";
import RxHarmonyLogo from "@/assets/images/rx-harmony-logo.svg";
import { mapGetters } from "vuex";

export default {
  name: "ForgotSuccessView",
  components: {
    PredictileLogo,
    RxHarmonyLogo,
  },
  computed: {
    ...mapGetters("organization", ["cobrandId"]),
    logo() {
      switch (this.cobrandId) {
        case "rx-harmony":
          return "rx-harmony-logo";
      }
      return "predictile-logo";
    },
    message() {
      return this.$route.query.message || "Your password was successfully updated.";
    },
  },
  methods: {
    href(path) {
      this.$router.push(path);
    },
  },
};
</script>
